"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMigrationBody = exports.validateMigrationUser = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateMigrationUser = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    access_code: (0, validation_1.optional)((0, validation_1.text)()),
    uuid: (0, validation_1.text)(),
});
exports.validateMigrationBody = (0, validation_1.properties)({
    users: (0, validation_1.array)(exports.validateMigrationUser),
});
//# sourceMappingURL=MigrationBody.js.map